export default __webpack_public_path__ + "static/media/kevlar.70459ed0.png";